export const mobilePanelPosition = {
  margin: '0 var(--sib-spacing_2) var(--sib-spacing_2) 0',
  bottom: '0px'
};
export const getPanelPosition = (trigger, panel, isMobile) => {
  const triggerAttributes = trigger?.getBoundingClientRect();
  const panelAttributes = panel?.getBoundingClientRect();
  const windowHeight = window.innerHeight;
  const panelHeight = panelAttributes?.height;
  const triggerBottom = triggerAttributes?.bottom;
  if (isMobile) {
    return {
      ...mobilePanelPosition
    };
  }
  if (triggerBottom + panelHeight <= windowHeight) {
    return {
      top: `${triggerAttributes?.bottom + window.scrollY || 0}px`,
      left: getLeftRightPosition(trigger, panel, isMobile).left,
      marginTop: 'var(--sib-spacing_2)'
    };
  }
  if (triggerAttributes?.top >= panelHeight) {
    return {
      top: `${triggerAttributes?.top - panelAttributes?.height + window.scrollY || 0}px`,
      left: getLeftRightPosition(trigger, panel, isMobile).left,
      marginTop: 'calc(0rem - var(--sib-spacing_2))'
    };
  }
  return {
    top: `${triggerAttributes?.bottom + window.scrollY || 0}px`,
    left: getLeftRightPosition(trigger, panel, isMobile).left,
    marginTop: 'var(--sib-spacing_2)'
  };
};
export const getLeftRightPosition = (trigger, panel, isMobile) => {
  const triggerAttributes = trigger?.getBoundingClientRect();
  const panelAttributes = panel?.getBoundingClientRect();
  const windowWidth = window.innerWidth;
  const triggerCenter = triggerAttributes?.left + triggerAttributes?.width / 2;
  const panelWidth = panelAttributes?.width;
  if (isMobile) {
    return {
      ...mobilePanelPosition
    };
  }
  if (windowWidth - (triggerCenter - panelWidth) >= panelWidth) {
    return {
      left: `${triggerCenter - panelWidth || 0}px`
    };
  }
  return {
    left: `${triggerCenter || 0}px`
  };
};